import i18next from 'i18next'

i18next.addResources('es', 'alerts', {
  danger: 'error-icon',
  warning: 'warning-icon',
  success: 'success-icon'
})
